import { FC } from "react";
import styled from "styled-components";
import {
  Button,
  ButtonVariant,
  Typography,
  TypographyVariant,
} from "../../../../components/ui-kit";
import { Cross } from "../../../../components/icons";
import { useModalManager } from "../../../../context/ModalManager";
import { CompanyApiType } from "../../../../util/types";
import { MarkTestCompaniesModal } from "./MarkTestCompaniesModal";

const BottomMenuContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px -15px 20px rgba(108, 108, 138, 0.1);
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  left: 0;
`;

const LeftSection = styled.div`
  padding: 25px 53px 25px 280px;
  display: flex;
  align-items: center;
  margin-right: auto;
  justify-content: space-between;
  @media (max-width: 900px) {
    padding: 25px;
  }
`;

const RightSection = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 0 62px 0 30px;
  @media (max-width: 900px) {
    padding: 0 24px 0 16px;
  }
`;

const StyledCross = styled(Cross)`
  margin-right: 11px;
  :hover {
    path {
      stroke: #13273f;
    }
    cursor: pointer;
  }
`;

const StyledTypography = styled(Typography)`
  line-height: 30px;
  padding-left: 11px;
  border-left: solid 1px #dbe3eb;
`;

interface MarkTestCompaniesBulkBarProps {
  selectedCompanies: CompanyApiType[];
  onClearSelection: () => void;
  onRefresh: () => Promise<unknown>;
}

export const MarkTestCompaniesBulkBar: FC<MarkTestCompaniesBulkBarProps> = ({
  selectedCompanies,
  onClearSelection,
  onRefresh,
}) => {
  const { addModal } = useModalManager();

  const openMarkModal = () => {
    addModal(
      <MarkTestCompaniesModal
        selectedCompanies={selectedCompanies}
        onClearSelection={onClearSelection}
        onRefresh={onRefresh}
        isTestCompany
      />
    );
  };

  const openUnmarkModal = () => {
    addModal(
      <MarkTestCompaniesModal
        selectedCompanies={selectedCompanies}
        onClearSelection={onClearSelection}
        onRefresh={onRefresh}
        isTestCompany={false}
      />
    );
  };

  return (
    <BottomMenuContainer>
      <LeftSection>
        <StyledCross onClick={onClearSelection} />
        <StyledTypography color="#495B6C" variant={TypographyVariant.HEADLINE}>
          Selected companies:{" "}
          <span style={{ color: "#13273F" }}>{selectedCompanies.length}</span>
        </StyledTypography>
      </LeftSection>
      <RightSection>
        <Button variant={ButtonVariant.CONTAINED} onClick={openMarkModal}>
          Mark as test company
        </Button>
        <Button variant={ButtonVariant.OUTLINED} onClick={openUnmarkModal}>
          Unmark test company
        </Button>
      </RightSection>
    </BottomMenuContainer>
  );
};
